import { ListingType } from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

const PropertyGridListingTypeContext = createContext<ListingType | undefined>(undefined);

export const PropertyGridListingTypeProvider = PropertyGridListingTypeContext.Provider;

export const usePropertyGridListingType = () => useContext(PropertyGridListingTypeContext);
